import React from "react";
import MapStatic from "../../common/MapStatic";
import { useLive } from "../LiveProvider";
import LiveHeader from "./LiveHeader";
import {
  Container,
  MapContainer,
  Overlay,
  Content,
  Grid,
  Cell,
  Title,
  Address,
  AddressDivider,
  Street,
  CityStateZip,
  Client,
  ClientDivider,
  Image
} from "./styled/live-hero";

function LiveHero() {
  const { subjectProperty, report } = useLive();
  const hasPhoto = !!subjectProperty.photo;

  return (
    <Container className={`hero ${hasPhoto ? "hero-has-photo" : ""}`}>
      {!!subjectProperty.coords.lat && !!subjectProperty.coords.lon && (
        <MapContainer className="hero-map-container">
          <MapStatic
            width={1280}
            height={383}
            lat={subjectProperty.coords.lat}
            lon={subjectProperty.coords.lon}
            pin={null}
          />
        </MapContainer>
      )}
      <Overlay className="hero-overlay">
        <LiveHeader />
        <Content hasPhoto={hasPhoto}>
          <Grid hasPhoto={hasPhoto}>
            <Cell className="hero-wrapper">
              <Title hasPhoto={hasPhoto} className="hero-title">
                {report.headline || "Comparative Market Analysis"}
              </Title>
              {(!!subjectProperty.street || !!subjectProperty.cityStateZip) && (
                <Address
                  hasPhoto={hasPhoto}
                  className="font-primary hero-address">
                  {!!subjectProperty.street && (
                    <Street
                      hasPhoto={hasPhoto}
                      classname="font-primary hero-street">
                      {subjectProperty.street}
                    </Street>
                  )}
                  {!!subjectProperty.cityStateZip && (
                    <>
                      <AddressDivider
                        hasPhoto={hasPhoto}
                        className="font-primary hero-divider">
                        ,{" "}
                      </AddressDivider>
                      <CityStateZip
                        hasPhoto={hasPhoto}
                        className="font-primary hero-city-state-zip">
                        {subjectProperty.cityStateZip}
                      </CityStateZip>
                    </>
                  )}
                </Address>
              )}
              <ClientDivider className="hero-client-divider" />
              <Client hasPhoto={hasPhoto} className="hero-client">
                Prepared for {report.title}
              </Client>
            </Cell>
            {hasPhoto && (
              <Cell>
                <Image
                  src={subjectProperty.photo}
                  alt={subjectProperty.address}
                  className="hero-subject-property-image"
                />
              </Cell>
            )}
          </Grid>
        </Content>
      </Overlay>
    </Container>
  );
}

export default LiveHero;
